import { v4 as uuidv4 } from "uuid";
import { Snackbar, SnackbarContent } from "types/snackbar";

export enum ACTIONS {
    ADD_SNACKBAR = "ADD_SNACKBAR",
    REMOVE_SNACKBAR = "REMOVE_SNACKBAR",
}

export const addSnackbar = ({ type, message, timeout = 3000 }: SnackbarContent): AddSnackbar => {
    return {
        type: ACTIONS.ADD_SNACKBAR,
        payload: {
            type,
            message,
            timeout,
            id: uuidv4(),
        },
    };
};

export const removeSnackbar = ({ id }: { id: string }) => {
    return {
        type: ACTIONS.REMOVE_SNACKBAR,
        payload: {
            id,
        },
    };
};

export interface AddSnackbar {
    type: ACTIONS.ADD_SNACKBAR;
    payload: Snackbar;
}

export interface RemoveSnackbar {
    type: ACTIONS.REMOVE_SNACKBAR;
    payload: {
        id: string;
    };
}

export type SnackbarAction = AddSnackbar | RemoveSnackbar;
